import qs from 'querystringify'
import remote from './remote'

// /clients/log (POST) 저장
// /clients/log (GET) 조회
// /clients/log (DELETE) 삭제

const URL = {
    SEARCH_LOG: '/cms/log',
    ADD_LOG: '/cms/log',
    DELETE_LOG: '/cms/log',
    SEARCH_LOGIN_LOG: '/cms/loginlog',
    ADD_LOGIN_LOG: '/cms/loginlog',
    DELETE_LOGIN_LOG: '/cms/loginlog'
}

export default {
  searchLog (option) {
      let url = remote.getUrl(URL.SEARCH_LOG)

      if (option) {
          url = url + '?' + qs.stringify(option)
      }

      return remote.request({
          url: url,
      })
  },
    addLog (log) {
        return remote.request({
            url: remote.getUrl(URL.ADD_LOG),
            method: remote.METHOD.POST,
            headers: {
                'Content-Type': 'application/json'
            },
            data: log
        })
    },
    deleteLog (log) {
        return remote.request({
            url: remote.getUrl(URL.DELETE_LOG),
            method: remote.METHOD.DELETE,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Array.isArray(log) ? log : [log],
        })
    },
    searchLoginLog (option) {
        let url = remote.getUrl(URL.SEARCH_LOGIN_LOG)
  
        if (option) {
            url = url + '?' + qs.stringify(option)
        }
  
        return remote.request({
            url: url,
        })
    },
      addLoginLog (log) {
          return remote.request({
              url: remote.getUrl(URL.ADD_LOGIN_LOG),
              method: remote.METHOD.POST,
              headers: {
                  'Content-Type': 'application/json'
              },
              data: log
          })
      },
      deleteLoginLog (log) {
          return remote.request({
              url: remote.getUrl(URL.DELETE_LOGIN_LOG),
              method: remote.METHOD.DELETE,
              headers: {
                  'Content-Type': 'application/json'
              },
              data: Array.isArray(log) ? log : [log],
          })
      }
}
